export * from './lib/core-resources.module';
export * from './lib/resource-manager';
export { ResourceManagerService } from './lib/resource-manager.service';
